export function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);

  var hDisplay = h + 'h';
  var mDisplay = m < 10 ? '0' + m : m;
  return hDisplay + mDisplay;
}
